import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../utils/AuthContext';
import { SettingsHubSection } from '../SettingsHubSection';

const ApiSettingsSection: React.FC = () => {
  const { user } = useAuth();
  return (
    <>
      {user?.role === 'admin' && (
        <p className="setting-description" style={{ margin: '0 0 12px' }}>
          Scoped employee / service-bot keys:{' '}
          <Link to="/settings/agent-api-keys">Settings → Agent API Keys</Link>
        </p>
      )}
      <SettingsHubSection section="api" />
    </>
  );
};

export default ApiSettingsSection;
